import React from "react";

/**
 * Simple error boundary — catches render/runtime errors in a subtree so a single
 * broken widget can't take down an entire page.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, err: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, err: error }; }
  componentDidCatch(error, info) { console.error("[ErrorBoundary]", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="border border-amber-300 bg-amber-50 p-4 text-xs" data-testid="widget-error">
          <div className="font-bold text-amber-900 mb-1">{this.props.label || "Widget"} konnte nicht geladen werden</div>
          <div className="text-amber-700">Bitte Seite neu laden. Falls der Fehler bestehen bleibt, wurde eventuell noch nicht deployed.</div>
        </div>
      );
    }
    return this.props.children;
  }
}
